var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('validation-provider',{ref:"provider",attrs:{"rules":{required: _vm.isVisible(_vm.field.identifier)},"mode":"passive","slim":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
var validated = ref.validated;
var valid = ref.valid;
return [_vm._t("default",null,{"input":_vm.handleInput,"error":errors[0],"validated":validated,"valid":valid})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }